import { useMutation, useQuery } from "@apollo/client";
import {
  Button,
  Image,
  ScrollArea,
  Skeleton,
  Text,
  Loader,
  Grid,
} from "@mantine/core";
import { useViewportSize } from "@mantine/hooks";
import {
  CONFIRM_DEPOSIT_SLIP,
  DIS_APPROVE_DEPOSIT_SLIP,
} from "apollo/mutuations";
import { DEPOSIT_SLIP, DEPOSIT_SLIPS } from "apollo/queries";
import { showNotification } from "@mantine/notifications";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { API } from "utiles/url";

const ManageDepositSlip = ({
  editId,
  setOpenedEdit,
  total,
  fetchData,
  setTotal,
  activePage,
  setActivePage,
}) => {
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const [imageLoading, setImageLoading] = useState(true);

  useEffect(() => {
    fetchDeposit();
  }, [editId]);

  const fetchDeposit = async () => {
    console.log(editId);
    setLoading(true);
    try {
      let token = localStorage.getItem("auth_token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      const { data } = await axios.get(
        `${API}/deposit-slips/${editId}`,
        config
      );
      console.log(data);
      if (data) {
        setLoading(false);
        setData(data);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching data:", error);
    }
  };

  const [confirmDeposit, { loading: confirmLoading }] = useMutation(
    CONFIRM_DEPOSIT_SLIP,
    {
      onCompleted(data) {
        showNotification({
          color: "green",
          title: "Success",
          message: "Approved Successfully",
        });
        fetchData(activePage);
        setOpenedEdit(false);
      },
      onError(error) {
        setOpenedEdit(false);
        showNotification({
          color: "red",
          title: "Error",
          message: error?.graphQLErrors?.[0]?.message || "Failed to Approv",
        });
      },
    }
  );
  const [disapproveDeposit, { loading: disapproveLoading }] = useMutation(
    DIS_APPROVE_DEPOSIT_SLIP,
    {
      onCompleted(data) {
        fetchData(activePage);
        setOpenedEdit(false);
      },
      onError(error) {
        setOpenedEdit(false);
        showNotification({
          color: "red",
          title: "Error",
          message: error?.graphQLErrors?.[0]?.message || "Failed to disapprove",
        });
      },
    }
  );

  const { height } = useViewportSize();

  const submit = (e) => {
    e.preventDefault();
    confirmDeposit({
      variables: {
        deposit_id: editId,
      },
    });
  };

  const disapprove = (e) => {
    e.preventDefault();
    disapproveDeposit({
      variables: {
        deposit_id: editId,
      },
    });
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
      <ScrollArea style={{ flex: 1, overflowY: "auto" }}>
        <Image
          height={height / 1.5}
          src={data?.slip || ""}
          alt="Deposit slip"
          withPlaceholder
          placeholder={<Text align="center">No slip Found!</Text>}
          onLoad={() => setImageLoading(false)}
          style={{
            display: "block",
            paddingTop: "20px",
          }}
        />
      </ScrollArea>

      <div
        style={{
          paddingTop: "20px",
          paddingBottom: "10px",
          display: "flex",
          justifyContent: "center",
          borderTop: "1px solid #eee",
        }}
      >
        <Skeleton height={8} visible={loading || confirmLoading}></Skeleton>
        {data?.confirmed_at ? (
          <Button
            style={{
              width: "40%",
              backgroundColor: "#FF6A00",
              color: "#FFFFFF",
            }}
            onClick={disapprove}
            disabled={disapproveLoading || confirmLoading}
            loading={disapproveLoading}
          >
            Reverse Approval
          </Button>
        ) : (
          <Button
            style={{
              width: "40%",
              backgroundColor: "#FF6A00",
              color: "#FFFFFF",
            }}
            onClick={submit}
            disabled={confirmLoading || disapproveLoading}
            loading={confirmLoading}
          >
            Approve Deposit
          </Button>
        )}
      </div>
    </div>
  );
};

export default ManageDepositSlip;
